import { makeRequest } from 'utils/requestLogger';

const editPoll = (poll_id, payload) =>
  makeRequest('put', `/api/polls/${poll_id}`, payload);

export default {
  editPoll,
};



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/polls/index.js